import {
	TransTerms,
	useTranslationTerms,
} from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';

export const PrivacyPolicyContent = () => {
	const tTerms = useTranslationTerms();

	return (
		<>
			<TransTerms i18nKey="privacy.text_1" />
			<ul>
				<li>{tTerms('privacy.data_list.item1')}</li>
				<li>{tTerms('privacy.data_list.item2')}</li>
				<li>{tTerms('privacy.data_list.item3')}</li>
				<li>{tTerms('privacy.data_list.item4')}</li>
				<li>{tTerms('privacy.data_list.item5')}</li>
				<li>{tTerms('privacy.data_list.item6')}</li>
				<li>{tTerms('privacy.data_list.item7')}</li>
				<li>{tTerms('privacy.data_list.item8')}</li>
			</ul>
			<TransTerms i18nKey="privacy.text_2" />
			<ul>
				<li>{tTerms('privacy.data_collect_list.item1')}</li>
				<li>{tTerms('privacy.data_collect_list.item2')}</li>
				<li>{tTerms('privacy.data_collect_list.item3')}</li>
				<li>{tTerms('privacy.data_collect_list.item4')}</li>
				<li>{tTerms('privacy.data_collect_list.item5')}</li>
			</ul>

			<TransTerms i18nKey="privacy.text_3" />
			<ul>
				<li>{tTerms('privacy.data_use_list.item1')}</li>
				<li>{tTerms('privacy.data_use_list.item2')}</li>
				<li>{tTerms('privacy.data_use_list.item3')}</li>
			</ul>

			<TransTerms i18nKey="privacy.text_4" />

			<ul>
				<li>{tTerms('privacy.personal_data_list.item1')}</li>
				<li>{tTerms('privacy.personal_data_list.item2')}</li>
				<li>{tTerms('privacy.personal_data_list.item3')}</li>
				<li>{tTerms('privacy.personal_data_list.item4')}</li>
			</ul>

			<TransTerms i18nKey="privacy.text_5" />

			<ul>
				<li>{tTerms('privacy.rights_list.item1')}</li>
				<li>{tTerms('privacy.rights_list.item2')}</li>
				<li>{tTerms('privacy.rights_list.item3')}</li>
				<li>{tTerms('privacy.rights_list.item4')}</li>
				<li>
					{tTerms('privacy.rights_list.item5')}
					<ul>
						<li>{tTerms('privacy.rights_list.item_5_sublist.item_1')}</li>
						<li>{tTerms('privacy.rights_list.item_5_sublist.item_2')}</li>
						<li>{tTerms('privacy.rights_list.item_5_sublist.item_3')}</li>
						<li>{tTerms('privacy.rights_list.item_5_sublist.item_4')}</li>
					</ul>
				</li>
				<li>{tTerms('privacy.rights_list.item_6')}</li>
				<li>{tTerms('privacy.rights_list.item_7')}</li>
			</ul>

			<TransTerms i18nKey="privacy.text_6" />
		</>
	);
};
